import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/surat-rujukan", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function sign(id, data) {
  const response = await http
    .putData(`/surat-rujukan/${id}/signature`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/surat-rujukan/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/surat-rujukan`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function listByPasien(rm: string | number) {
  const response = await http
    .getData(`/pasien/${rm}/surat-rujukan`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function saranUnitTujuan(tujuanId?: string | number | null) {
  const query = tujuanId ? `?tujuan_id=${encodeURIComponent(String(tujuanId))}` : "";
  const response = await http
    .getData(`/surat-rujukan/saran-unit-tujuan${query}`)
    .catch(err => {
      ErrorAlert.showSnackAlert(err, "Saran Unit/Klinik Tujuan");

      return Promise.reject(err);
    });

  return response;
}

async function find(id: number) {
  const response = await http.getData(`/surat-rujukan/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/surat-rujukan/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  const data = isEmpty(response?.data) ? null : response.data;

  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/surat-rujukan/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  listByPasien,
  saranUnitTujuan,
  find,
  sign,
  destroy,
  print
};
